import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Rewards from "./pages/Rewards";
import HowToClaim from "./pages/HowToClaim";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/how-to-claim" element={<HowToClaim />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
        </Routes>
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: '#16191e',
              border: '1px solid #2d3442',
              color: '#ffffff',
              fontFamily: 'Rajdhani, sans-serif',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
